import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  CircularProgress,
  Alert
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { addCreditToWalletByUserId } from '../../services/financeService';

const AddCreditAdminModal = ({ open, onClose, userId, onCreditAdded }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAddCredit = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      setError('Por favor, introduce un monto válido.');
      return;
    }
    if (!description) {
      setError('Por favor, introduce una descripción.');
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await addCreditToWalletByUserId(userId, parseFloat(amount), description);
      onCreditAdded();
      onClose();
    } catch (err) {
      setError('Error al añadir crédito.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 4,
      }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Añadir Recarga
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          fullWidth
          label="Monto"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Descripción"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button
          fullWidth
          variant="contained"
          onClick={handleAddCredit}
          disabled={loading}
          sx={{
            background: 'linear-gradient(135deg, #002642 0%, #00577A 100%)',
          }}
        >
          {loading ? <CircularProgress size={24} /> : 'Añadir Crédito'}
        </Button>
      </Box>
    </Modal>
  );
};

export default AddCreditAdminModal;